import { FileText, Lock, Shield } from "lucide-react";
import { Footer } from "../components/layout/Footer";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-cream pb-24 md:pb-8" data-testid="terms-page">
      <header className="bg-teal-700 text-white px-6 pt-8 pb-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-serif flex items-center gap-3"><FileText size={28} /> Terms & Conditions</h1>
          <p className="text-teal-200 text-sm mt-2">Last updated: March 2026</p>
        </div>
      </header>

      <div className="px-6 py-8 max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl p-6 border border-stone-100 space-y-6">
          <section>
            <h2 className="text-xl font-serif text-stone-900 mb-3">1. Acceptance of Terms</h2>
            <p className="text-stone-600">
              By accessing or using OspitAI ("the Service"), you agree to be bound by these Terms and Conditions. 
              If you disagree with any part of these terms, you may not access the Service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-serif text-stone-900 mb-3">2. Description of Service</h2>
            <p className="text-stone-600">
              OspitAI is a digital concierge platform that connects guests with local services, recommendations, 
              and bookable experiences in Puglia, Italy. The Service includes:
            </p>
            <ul className="list-disc list-inside text-stone-600 mt-2 space-y-1">
              <li>AI-powered concierge assistance</li>
              <li>Local recommendations for beaches, restaurants, and events</li>
              <li>Bookable services including transfers, experiences, and late checkout</li>
              <li>Host property management tools</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-serif text-stone-900 mb-3">3. User Accounts</h2>
            <p className="text-stone-600">
              Hosts must create an account to access the dashboard. You are responsible for maintaining the 
              confidentiality of your account credentials and for all activities under your account.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-serif text-stone-900 mb-3">4. Bookings and Payments</h2>
            <p className="text-stone-600">
              Payments for bookable services are processed securely through Stripe. By making a booking, you agree to:
            </p>
            <ul className="list-disc list-inside text-stone-600 mt-2 space-y-1">
              <li>Provide accurate payment information</li>
              <li>Accept that certain bookings may require confirmation</li>
              <li>Acknowledge that cancellation policies vary by service</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-serif text-stone-900 mb-3">5. Intellectual Property</h2>
            <p className="text-stone-600">
              All content, trademarks, and intellectual property displayed on OspitAI are owned by or licensed to us. 
              Unauthorized reproduction or distribution is prohibited.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-serif text-stone-900 mb-3">6. Limitation of Liability</h2>
            <p className="text-stone-600">
              OspitAI provides recommendations in good faith but cannot guarantee the quality, safety, or availability 
              of third-party services. We are not liable for any damages arising from your use of recommended services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-serif text-stone-900 mb-3">7. Governing Law</h2>
            <p className="text-stone-600">
              These Terms shall be governed by and construed in accordance with the laws of Italy and the European Union, 
              without regard to conflict of law provisions.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-serif text-stone-900 mb-3">8. Contact</h2>
            <p className="text-stone-600">
              For questions about these Terms, please contact us at legal@ospitai.com
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}
